<!--
 * @Description: 
 * @Date: 2022-02-24 16:52:04
-->
<template>
  <el-drawer
    title="任务详情"
    :visible="true"
    :wrapperClosable="false"
    :before-close="() => $emit('remove')"
  >
    <center class="rectitle" v-if="isUnqualified">
      <div class="rectitle-text">
        <span style=" font-size: 16px;color: #EA0D0D;">
          不可结算
        </span>
        <span style="font-size:14px">数据检测不合格，系统已自动拦截</span>
      </div>
    </center>
    <el-alert
      v-if="+form.auditOssStatus === 3"
      :title="`审核未通过：${form.auditOpinion || '-'}`"
      type="warning"
      :closable="false"
    ></el-alert>
    <div class="task-detail-container" @click="fileViewerFocus">
      <el-form :model="form" class="form">
        <el-form-item label="文件夹名称：">
          {{ form.folderName }}
        </el-form-item>
        <el-form-item label="上传附件数：">
          {{ form.fileNum }}
        </el-form-item>
        <el-form-item label="审核状态：">
          {{
            ['未提交审核', '审核中', '审核通过', '审核未通过'][
              form.auditOssStatus
            ]
          }}
        </el-form-item>
        <el-form-item label="文件名称：">
          <el-tooltip
            v-for="(item, index) in formFileList"
            :key="item.fileId"
            effect="dark"
            :content="item.fileName"
            placement="left"
          >
            <div style="display: flex; align-items: center;width: 15vw;">
              <el-button
                class="ellipsis"
                @click="showFileDetail(item.values)"
                type="text"
              >
                {{ item.fileName }}
              </el-button>
              <img
                @click="$downloadFile(item.values, true)"
                src="@R/imgs/download.png"
                class="pointer"
                style="width:15px;height:15px;margin:0 50px 0 10px;"
              />
              <el-button @click="deleteFile(item.fileId, index)" type="text">
                删除
              </el-button>
            </div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="上传时间：">
          {{ form.createDt }}
        </el-form-item>
      </el-form>
    </div>
    <fileViewer
      ref="fileViewer"
      :initialIndex="fileViewerIndex"
      :fileList="fileViewerList"
    />
  </el-drawer>
</template>

<script>
import fileViewer from '@R/components/file-viewer.vue';
import { activity } from '@/api/ajax.js';
import setFileViewerList, {
  getFileType
} from '@R/services/set-file-viewer-list';
export default {
  name: 'active-detail',
  components: {
    fileViewer
  },
  props: ['sersviceActivityId', 'isUnqualified'],
  data() {
    return {
      form: {
        folderName: '',
        fileNum: '',
        submitStatus: '',
        submitDt: ''
      },
      fileViewerIndex: `0_${Date.now()}`,
      fileViewerList: [], //这个是左侧图片预览集合
      formFileList: [] //这个是右侧form文件名称渲染集合
    };
  },
  methods: {
    setFileViewerIndex(url) {
      const index = this.fileViewerList.findIndex(item => item.url === url);
      if (~index) {
        this.fileViewerIndex = `${index}_${Date.now()}`;
      }
    },
    showFileDetail(values) {
      const fileType = getFileType(values);
      if (['zip', 'file'].includes(fileType)) {
        this.$previewFile(values);
      } else {
        this.setFileViewerIndex(values);
      }
    },
    fileViewerFocus() {
      this.$nextTick(() => {
        this.$refs['fileViewer'].$refs['el-image-viewer__wrapper'].focus();
      });
    },
    deleteFile(fileId, index) {
      this.$confirm('是否确认删除，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          activity
            .deleteFile({ sersviceActivityId: this.sersviceActivityId, fileId })
            .then(() => {
              //删除成功
              this.formFileList.splice(index, 1);
              this.fileViewerList.filter(item => item.fileId !== fileId);
              this.$message.success('删除成功！');
              this.initForm();
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    initForm() {
      activity
        .detail({ sersviceActivityId: this.sersviceActivityId })
        .then(res => {
          const { files } = res.data.data;
          this.form = res.data.data;
          this.formFileList = files.map(item => {
            return {
              ...item,
              values: item.fileUrl
            };
          });
          this.fileViewerList = setFileViewerList(this.formFileList);
        });
    }
  },
  created() {
    this.initForm();
  }
};
</script>

<style scoped lang="scss">
$action-bar-height: 80px;
>>> .el-form {
  padding: 10px 16px;
}
.task-detail {
  &-container {
    height: calc(100vh - 78px);
    position: relative;
    overflow-y: scroll;
    padding: 0 5px $action-bar-height;
    >>> .el-form-item__content {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
    }
    >>> .el-form-item__label {
      width: 140px;
      font-size: 15px;
      font-weight: bold;
    }
  }

  &-actions {
    height: $action-bar-height;
    background: #fff;
    border-top: 1px solid #c1c1c1;
    width: 100%;
    position: absolute;
    bottom: 0;
    padding: 10px 50px;
  }
}
::v-deep .el-image-viewer__wrapper {
  width: 70% !important;
}
.rectitle {
  height: 50px;
  margin: 0 20px;
  background-color: rgba(247, 217, 217, 1);
  border-radius: 10px;
  margin-bottom: 15px;
  &-text {
    line-height: 50px;
  }
}
</style>
